// extracted by mini-css-extract-plugin
export default {"root":"ModalParagraph_root__3DRBO"};